'use strict';

/*global services*/
/*global nl2br*/
/*global normalizeInput*/

function OutputService() {
  this.modal = null;

  this.init();
}

OutputService.prototype = $.extend({}, {
  constructor: 'OutputService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  showMessage: function showMessage(data, callback) {
    var _this = this;

    data = normalizeInput(data);

    var content = data.content;

    var styles = '';
    var modalStyles = '';
    if (data.isWarning) {
      styles += ' text-danger font-size-150per ';
      modalStyles += ' modal-danger ';
    }

    if (data.asHtml) {
      content = '<p class="text-center ' + styles + '">' + nl2br(content) + '</p>';
    }

    _this.modal.open({
      title: data.title,
      height: 'auto',
      width: 'md',
      modalClass: modalStyles,
      content: content,
      closeCallBack: callback
    });

    return _this;
  },

  showMessageHtml: function showMessageHtml(data, callback) {
    var _this = this;

    data = normalizeInput(data);

    data.asHtml = true;

    _this.showMessage(data, callback);

    return _this;
  },

  showWarningHtml: function (data, callback) {
    var _this = this;

    data = normalizeInput(data);

    data.asHtml = true;
    data.isWarning = true;

    _this.showMessage(data, callback);

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-output');

    _this.registerCallbacks();

    return _this;
  }
});
